import parse from 'date-fns/parse'

/** Converts a "month string" (ie 11/18) to a date object ("2018-11-01T00:00:00") */
export default (month: string): Date => {
  const [m, y] = month.split('/')
  return parse(`20${y}-${m}-01`, 'yyyy-MM-dd', new Date())
}
